// src/js/pages/vue-example.ts
import { registerPageInit } from '../barba/page-init-registry';
import '../../css/_root.scss';
import { createApp } from 'vue';
import App from '@/js/widgets/TestComponent.vue';

import Button from 'primevue/button';
import DatePicker from 'primevue/datepicker';

import PrimeVue from 'primevue/config';
import Aura from '@primeuix/themes/aura';

class VueExamplePage {
  constructor() {}

  public init(): void {
    const appElement = document.getElementById('app');
    if (appElement) {
      const app = createApp(App);
      app.use(PrimeVue, {
        theme: {
          preset: Aura,
        },
      });

      app.component('Button', Button);
      app.component('DatePicker', DatePicker);
      app.mount('#app');
    }
  }
}

registerPageInit('vue-example', () => {
  const page = new VueExamplePage();
  page.init();
});
